
const SearchRequest = {
    "flightSteps": [
      {
        "originCode": "IKA",
        "destinationCode": "IST",
        "departureDate": "2023-02-25"
      }
      , {
        "originCode": "IST",
        "destinationCode": "IKA",
        "departureDate": "2023-02-28"
      }
    ],
    "searchedPassenger": {
      "adt": 1,
      "inf": 0,
      "chd": 0
    },
    "flightPreferences": {
      "cabinClass": 100,
      "tripType": 2
    }
  };
 

  export default SearchRequest;
  